import { useState, useEffect } from 'react';
import checkUserInfo from './check-user-info.esm.js';

function useUser() {
    const [user, setUser] = useState({
        isLoggedIn: true,
        isLoading: true
    });
    useEffect(()=>{
        const { id: userId = 0 } = checkUserInfo() || {};
        setUser({
            isLoggedIn: userId !== undefined && userId > 0,
            isLoading: false
        });
    }, []);
    return user;
}
const UserStatus = {
    loading: 'loading',
    loggedIn: 'loggedIn',
    loggedOut: 'loggedOut'
};
const useUserStatus = ()=>{
    const user = useUser();
    if (user.isLoading) {
        return UserStatus.loading;
    }
    if (user.isLoggedIn) {
        return UserStatus.loggedIn;
    }
    return UserStatus.loggedOut;
};

export { UserStatus, useUser as default, useUser, useUserStatus };
